<template>
	<div class="banner">
		<el-carousel :interval="4000" height="399px">
			<el-carousel-item v-for="item in notices1" :key="item.id">
				<img width="100%" height="399" :src="item.imgUrl" />
			</el-carousel-item>
		</el-carousel>
	</div>
</template>
<script>
	export default {
		name: "AucBanner",
		data() {
			return {
				//访问前缀，用于区分环境，访问api时使用
				service_url: process.env.VUE_APP_SERVICE_URL ? process.env.VUE_APP_SERVICE_URL : '',
				notices1:[]
			};
		},
		methods:{
			//初始化预告
			init_notices_1(){
				this.getRequest(this.service_url + "/aucNotice/notices/1").then(resp => {
					if (resp) {
						this.notices1 = resp.data;
					} 
				})
			},
		},
		mounted() {
			this.init_notices_1();
		},
		components: {}
	};
</script>
<style>
.el-carousel__item h3 {	color: #475669;	font-size: 14px; opacity: 0.75;	line-height: 399px;	margin: 0; }
.el-carousel__button { width: 15px; height: 15px; border-radius: 15px; }
.el-carousel__item:nth-child(2n) { background-color: #99a9bf;}
.el-carousel__item:nth-child(2n+1) { background-color: #d3dce6;}
</style>